<template>

    <div class="vue-btn fav" v-bind:class="{thinking : thinking}" v-on:click.stop="setFav"><i class="fa-heart" v-bind:class="{ 'fas': fav,  'far': !fav}"></i></div>

</template>


<script>

    module.exports = {

        name: 'FavouriteWidget',

        data() {

            return {

                thinking: false,

            }

        },

        props: {

            post: Object,

            logged_in: {

                type: Boolean,
                default: false,

            }

        },

        computed: {

            fav() {

                return this.post.lc_is_fav;
            },

        },

        methods: {

            setFav() {

                console.log('setting fav for ' + this.post['ID']);

                if(this.thinking === true) return false;

                this.thinking = true;

                coreHelpers.ajax('POST', 'toggle_favourite', {

                    'post_id': this.post['ID']

                }, this.setFavSuccess, this.setFavFailure);

            },

            setFavSuccess(res) {

                console.log('success', res);
                this.post.lc_is_fav = res.data.fav;
                this.thinking = false;

                let action = res.data.fav ? 'Added' : 'Removed';
                window.lcGA('Favourite', action, res.data.post_id);

            },

            setFavFailure(res) {

                console.log('fail', res);
                this.thinking = false;

            },
        }
    }

</script>